import { h, Component } from 'preact';
import {connect} from 'react-redux'
import style from './style.less'

@connect((state)=>({
	...state
}))
export default class Footer extends Component {
	constructor(){
        super()
    }

	render(){
		return (
            <a href="https://www.nextinline.io/" class={style.footer}>
                Powered by Next In Line
            </a>
		);
	}
}



// WEBPACK FOOTER //
// ./components/elements/Footer/index.js